module.exports = __webpack_public_path__ + "static/media/4.059191e0.jpg";